// src/routes/AdminRoutes.js

import React from "react";
import { Routes, Route } from "react-router-dom";
import ResponsiveDrawer from "../components/sidebar";
import Phases from "../screens/user/phases";
import AddTime from "../screens/user/time/add";
import Dashboard from "../screens/user/dashboard";
import ProjectDetailPage from "../screens/user/ProjectDetails";
import ViewTimeSheet from "../screens/user/time/container/Timesheet";

function UsersRoutes() {
  return (
    <ResponsiveDrawer>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/phases" element={<Phases />} />
        <Route path="/time/add" element={<ViewTimeSheet />} />
        <Route path="/project-details" element={<ProjectDetailPage />} />
        <Route path="/view-time-sheet/:id" element={<ViewTimeSheet />} />
      </Routes>
    </ResponsiveDrawer>
  );
}

export default UsersRoutes;
